import React from 'react';
import './inventory.css';
import { connect } from 'react-redux';
import {
  updateSelectedInventory,
  updateInventoryFilter
} from '../../../actions/adminActions/adminInventoryActions';
import { inventory, rentals } from '../../../apis/backend';
import AddModal from './inventoryModals/addModal';
import EditModal from './inventoryModals/editModal';

class Inventory extends React.Component {
  async objectDeleteRequest(id) {
    await inventory
      .delete(`/${id}`, {
        headers: { authorization: this.props.employeeToken }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  async handleCheckIn(id) {
    await rentals
      .patch(`/checkin/${id}`, {}, { headers: { authorization: this.props.employeeToken } })
      .catch((err) => {
        console.log(err);
      });
  }

  renderInventory() {
    //renders the users table
    return (
      <>
        {this.props.inventory
          .filter((obj) => {
            const filterString = `${obj.type} ${obj.itemNumber} ${obj.status} ${obj.comment} ${obj.available} ${obj.comments}`;
            return (
              filterString.toLowerCase().indexOf(this.props.inventoryFilter.toLowerCase()) > -1
            );
          })
          .map((invent) => (
            <tr key={this.props.inventory.indexOf(invent)}>
              <td className="text-center" style={{ width: '5%' }}>
                {invent.itemNumber}
              </td>
              <td className="text-center" style={{ width: '15%' }}>
                {invent.type}
              </td>
              <td className="text-center" style={{ width: '15%' }}>
                {invent.status}
              </td>
              <td className="text-center " style={{ width: '15%' }}>
                {invent.available}
              </td>
              <td className="text-center " style={{ width: '20%' }}>
                {invent.comments}
              </td>
              <td className="text-center " style={{ width: '10%' }}>
                <div
                  data-target="#exampleModal"
                  className="btn btn-sm btn-dark"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedInventory(invent.id);
                  }}
                >
                  Edit
                </div>
              </td>
              <td className="text-center " style={{ width: '10%' }}>
                {invent.rentalId ? (
                  <div
                    // data-target="#exampleModal"
                    className="btn btn-sm btn-dark"
                    data-toggle="modal"
                    onClick={() => this.handleCheckIn(invent.rentalId)}
                  >
                    Check-In
                  </div>
                ) : (
                  <div />
                )}
              </td>
              <td className="text-center " style={{ width: '10%' }}>
                <div
                  className="btn btn-sm btn-dark"
                  data-target="#deleteModal"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedInventory(invent.id);
                  }}
                >
                  Remove
                </div>
              </td>
            </tr>
          ))}
      </>
    );
  }

  getInventoryItemName() {
    const item = this.props.inventory.find((obj) => obj.id === this.props.selectedInventory);

    return item ? item.type + ' ' + item.itemNumber : '';
  }

  render() {
    return (
      <div className="users-page">
        <div className="container">
          <div
            className="form-inline md-form form-sm mt-4"
            style={{ fontSize: '36px', color: '#fff' }}
          >
            <div style={{ margin: 'auto', height: '48px', width: '100%' }}>Inventory Items</div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <input
              value={this.props.inventoryFilter}
              className="form-control form-control-lg w-45"
              type="text"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                this.props.updateInventoryFilter(e.target.value);
              }}
            />
            <div
              data-target="#addModal"
              className="btn btn-lg btn-dark"
              data-toggle="modal"
              style={{ marginLeft: '10px' }}
            >
              Add Inventory
            </div>
          </div>
          <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table className="table table-striped  table-bordered table-hover bg-white mt-1 mr-3">
              <thead className="bg-dark thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '5%' }}>
                    Number
                  </th>
                  <th className="text-center" style={{ width: '15%' }}>
                    Type
                  </th>
                  <th className="text-center" style={{ width: '15%' }}>
                    Status
                  </th>
                  <th className="text-center" style={{ width: '15%' }}>
                    Available
                  </th>
                  <th className="text-center" style={{ width: '20%' }}>
                    Comments
                  </th>
                  <th className="text-center" style={{ width: '10%' }}>
                    Edit
                  </th>
                  <th className="text-center" style={{ width: '10%' }}>
                    CheckIn
                  </th>
                  <th className="text-center" style={{ width: '10%' }}>
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderInventory()}</tbody>
            </table>
          </div>
        </div>

        <AddModal />

        <EditModal />

        <div className="modal fade" id="deleteModal" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: '80%', margin: '0 auto' }}>
              <div className="modal-header">
                <h5 className="modal-title">Are you Sure?</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.updateSelectedInventory(0);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: 'center', fontSize: '18px' }}>
                <strong>&apos;{this.getInventoryItemName()}&apos;</strong> will be deleted forever!!
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.objectDeleteRequest(this.props.selectedInventory);
                    this.props.updateSelectedInventory(0);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.updateSelectedInventory(0);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  inventory: state.admin.admin.inventory,
  inventoryFilter: state.admin.inventory.inventoryFilter,
  selectedInventory: state.admin.inventory.selectedInventory,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {
  updateSelectedInventory,
  updateInventoryFilter
})(Inventory);
